import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container-fluid",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "text-dark" }
const _hoisted_5 = { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }
const _hoisted_6 = { class: "col-lg-6 text-right align-self-end" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "table table-bordered table-hover text-center" }
const _hoisted_10 = { class: "align-middle" }
const _hoisted_11 = { class: "align-middle" }

import { computed, onMounted, watch, ref, type Ref } from 'vue'
    import { useRoute, onBeforeRouteLeave } from 'vue-router'

    import { SavingState } from '@common/Common'
    import CorporateNavigation from '@common/Components/CorporateNavigation.vue'
    import EditableValueSeriesSheet from '@common/Components/EditableValueSeriesSheet.vue'
    import SaveButton from '@common/Components/SaveButton.vue'

    import type { KendoSpreadsheetColumn, KendoSpreadsheetValueSerie } from "@Kendo/Components/Spreadsheet/types"
    import type { ResourceCapacityPageReadModel } from '@Quest/Resources/readmodels'

    import { useResourceCapacityPageQueryV1 } from '@Quest/Resources/queries-vue-composables'
    import { useUpdateResourceCapacitiesCommandV1 } from '@Quest/Resources/commands-vue-composables'


    // ----------------------------------------------------
    // Route params
    // ----------------------------------------------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ResourceCapacitiesPage',
  setup(__props) {

    const route = useRoute()

    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const strategyId = computed(() => String(route.params.strategyId ?? ''))
    const resourceId = computed(() => String(route.params.resourceId ?? ''))


    // ----------------------------------------------------
    // Query
    // ----------------------------------------------------

    const {
        runResourceCapacityPageQueryV1,
        modelResourceCapacityPageQueryV1
    } = useResourceCapacityPageQueryV1(workspaceId, strategyId, resourceId)

    const rm = modelResourceCapacityPageQueryV1 as Ref<ResourceCapacityPageReadModel | null>


    // ----------------------------------------------------
    // Command
    // ----------------------------------------------------

    const {
        invokeUpdateResourceCapacitiesCommandV1,
        succeedUpdateResourceCapacitiesCommandV1
    } = useUpdateResourceCapacitiesCommandV1(workspaceId, strategyId)


    // ----------------------------------------------------
    // Local state
    // ----------------------------------------------------

    const isEditing = ref(false)
    const savingState = ref<SavingState>(SavingState.Saved)


    // ----------------------------------------------------
    // Computed
    // ----------------------------------------------------

    const title = computed(() => `${rm.value?.ResourceName ?? ''}`)

    const stopEditingLabel = computed(() =>
        savingState.value === SavingState.Pending
            ? "Cancel editing"
            : "Back"
    )

    const inputSeries = computed<KendoSpreadsheetValueSerie[]>(() =>
        rm.value
            ? rm.value.Years.map(y => ({
                Id: y.Year.toString(),
                Name: y.Year.toString(),
                Values: y.Values
            }))
            : []
    )

    const columns = computed<KendoSpreadsheetColumn[]>(() => [
        { Label: "Jan" }, { Label: "Feb" }, { Label: "Mar" }, { Label: "Apr" },
        { Label: "May" }, { Label: "Jun" }, { Label: "Jul" }, { Label: "Aug" },
        { Label: "Sep" }, { Label: "Oct" }, { Label: "Nov" }, { Label: "Dec" }
    ])


    // ----------------------------------------------------
    // Methods
    // ----------------------------------------------------

    const startEditing = () =>
    {
        isEditing.value = true
    }

    const cancelEditing = () =>
    {
        if (savingState.value === SavingState.Saved)
        {
            isEditing.value = false
        }
        else if (
            savingState.value === SavingState.Pending &&
            confirm("You have unsaved changes. Are you sure you want to cancel editing?")
        )
        {
            savingState.value = SavingState.Saved
            isEditing.value = false
        }
    }

    const onDataChange = () =>
    {
        savingState.value = SavingState.Pending
    }

    const sheet = ref<any>(null)

    const handleSaveCommand = () =>
    {
        const entries = sheet.value?.getEntriesForSave()

        invokeUpdateResourceCapacitiesCommandV1({
            resourceId: resourceId.value,
            entries
        })

        savingState.value = SavingState.InProgress
    }


    // ----------------------------------------------------
    // Lifecycle
    // ----------------------------------------------------

    onMounted(() =>
    {
        document.title = "Resource | TransparentChoice"
        runResourceCapacityPageQueryV1()
    })


    // ----------------------------------------------------
    // Command succeed watcher
    // ----------------------------------------------------

    watch(
        succeedUpdateResourceCapacitiesCommandV1,
        (current, previous) =>
        {
            if (current && !previous)
            {
                runResourceCapacityPageQueryV1()

                if (savingState.value === SavingState.InProgress)
                {
                    savingState.value = SavingState.Saved
                }
            }
        }
    )


    // ----------------------------------------------------
    // Route guard
    // ----------------------------------------------------

    onBeforeRouteLeave((to, from, next) =>
    {
        if (savingState.value === SavingState.Pending)
        {
            if (confirm("You have unsaved changes. Do you want to save them before leaving?"))
            {
                handleSaveCommand()
                next()
            }
            else
            {
                next()
            }
        }
        else
        {
            next()
        }
    })

return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CorporateNavigation, { ActivePage: "resources" }),
    (_unref(rm))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h6", null, [
                _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_4, [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("i", {
                    class: "fa fa-angle-double-left",
                    "aria-hidden": "true"
                  }, null, -1 /* CACHED */),
                  _createTextVNode(" Back to resources ", -1 /* CACHED */)
                ]))])), [
                  [_directive_sanitizedHref, `/#/enterprise/resources/${workspaceId.value}/${strategyId.value}`]
                ])
              ]),
              _createElementVNode("h1", _hoisted_5, _toDisplayString(_unref(rm).ResourceName), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_6, [
              (isEditing.value)
                ? (_openBlock(), _createBlock(SaveButton, {
                    key: 0,
                    savingState: savingState.value,
                    onSaveChanges: _cache[0] || (_cache[0] = ($event: any) => (handleSaveCommand()))
                  }, null, 8 /* PROPS */, ["savingState"]))
                : _createCommentVNode("v-if", true),
              (isEditing.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn btn-outline-secondary",
                    style: {"padding":"0.7em 2em"},
                    onClick: cancelEditing
                  }, _toDisplayString(stopEditingLabel.value), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              (!isEditing.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: "btn btn-success",
                    style: {"padding":"0.7em 2em"},
                    onClick: startEditing
                  }, "Edit capacity"))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 60px"} }, null, -1 /* CACHED */)),
          (isEditing.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _cache[2] || (_cache[2] = _createElementVNode("div", {
                  class: "alert alert-warning",
                  role: "alert"
                }, " Warning: Formula entered here will save as values. ", -1 /* CACHED */)),
                _createVNode(EditableValueSeriesSheet, {
                  ref_key: "sheet",
                  ref: sheet,
                  propTitle: title.value,
                  propSeries: inputSeries.value,
                  propColumns: columns.value,
                  onDataChange: onDataChange
                }, null, 8 /* PROPS */, ["propTitle", "propSeries", "propColumns"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("table", _hoisted_9, [
                  _cache[3] || (_cache[3] = _createElementVNode("thead", { class: "thead-light" }, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", {
                        rowspan: "2",
                        class: "align-middle"
                      }, "Year"),
                      _createElementVNode("th", {
                        colspan: "12",
                        class: "align-middle"
                      }, "Months"),
                      _createCommentVNode("<th rowspan=\"2\" class=\"align-middle table-secondary\">Total</th>")
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", { class: "align-middle" }, "1"),
                      _createElementVNode("th", { class: "align-middle" }, "2"),
                      _createElementVNode("th", { class: "align-middle" }, "3"),
                      _createElementVNode("th", { class: "align-middle" }, "4"),
                      _createElementVNode("th", { class: "align-middle" }, "5"),
                      _createElementVNode("th", { class: "align-middle" }, "6"),
                      _createElementVNode("th", { class: "align-middle" }, "7"),
                      _createElementVNode("th", { class: "align-middle" }, "8"),
                      _createElementVNode("th", { class: "align-middle" }, "9"),
                      _createElementVNode("th", { class: "align-middle" }, "10"),
                      _createElementVNode("th", { class: "align-middle" }, "11"),
                      _createElementVNode("th", { class: "align-middle" }, "12")
                    ])
                  ], -1 /* CACHED */)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rm).Years, (y) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: y.Year
                      }, [
                        _createElementVNode("td", _hoisted_10, _toDisplayString(y.Year), 1 /* TEXT */),
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (i) => {
                          return _createElementVNode("td", _hoisted_11, _toDisplayString(y.Values[i-1]), 1 /* TEXT */)
                        }), 64 /* STABLE_FRAGMENT */)),
                        _createCommentVNode("<td class=\"align-middle table-secondary\"></td>")
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ])
              ]))
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})